import Feature29 from './Feature29'
export default Feature29
